import styled from "styled-components";
import { viewSizeCalculator } from "../../utils";
import { views } from "../../Configs/config";

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${() => `${viewSizeCalculator(0.625)}`}; // 0.625rem
  width: ${(props) => (props?.view === views.MAP ? "65%" : "100%")};
  height: 100%;
  padding: ${() =>
    `${viewSizeCalculator(2)} ${viewSizeCalculator(3.375)}
     ${viewSizeCalculator(2.625)} ${viewSizeCalculator(3.375)}`};

  border-radius: ${() => `${viewSizeCalculator(1.25)}`}; // 1.25rem
  background-color: #fff;

  box-shadow: 0rem 0.0625rem 0.3125rem 0rem #3333331a;
`;

export const TopSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const TitleContainer = styled.div`
  // width: ${() => `${viewSizeCalculator(8.875)}`};
  display: flex;
  align-items: center;
  gap: ${() => `${viewSizeCalculator(0.75)}`}; // 0.75
  letter-spacing: ${() => `${viewSizeCalculator(0.0625)}`};
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${() => `${viewSizeCalculator(0.75)}`};
`;

export const ViewContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  gap: ${() => `${viewSizeCalculator(0.625)}`}; // 0.625rem
`;

export const Count = styled.p`
  font-size: ${() => `${viewSizeCalculator(1.25)}`}; // 1.25rem
  font-weight: 700;
  line-height: ${() => `${viewSizeCalculator(1.5125)}`};
`;

export const Title = styled.span`
  font-size: ${() => `${viewSizeCalculator(1.25)}`}; // 1.25rem
  font-weight: 700;
  line-height: ${() => `${viewSizeCalculator(2.625)}`}; // 2.625rem
  color: #333;
`;

export const FilterBox = styled.div`
  width: ${() => `${viewSizeCalculator(2.5)}`}; // 3rem;
  height: ${() => `${viewSizeCalculator(2.5)}`}; // 3rem;
  border-radius: ${() => `${viewSizeCalculator(1.042)}`}; // 1.25rem
  border: ${() =>
    `${viewSizeCalculator(0.125)} solid #ebebeb`}; // 0.125rem solid #ebebeb;
  /* background-color: #ffffff; */

  background-color: ${({ isHovered }) => (isHovered ? "#F6F6F6" : "#ffffff")};

  display: flex;
  align-items: center;
  justify-content: center;

  cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "pointer")};
  position: relative;
  svg {
    opacity: ${({ isDisabled }) => (isDisabled ? "20%" : "1")};
    width: ${() => `${viewSizeCalculator(1.25)}`}; // 1.25rem;
    height: ${() => `${viewSizeCalculator(1.25)}`}; // 1.25rem;
  }
`;

export const CrossWrapper = styled.div`
  cursor: pointer;
  svg {
    width: ${() => `${viewSizeCalculator(1.5)}`}; // 2.5rem;
    height: ${() => `${viewSizeCalculator(1.5)}`}; // 2.5rem;
  }
`;

export const CompareIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    width: ${() => `${viewSizeCalculator(1.5)}`}; // 2.5rem;
    height: ${() => `${viewSizeCalculator(1.5)}`}; // 2.5rem;
  }
`;

export const GraphSection = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
`;

export const Slider = styled.div`
  width: ${() => `${viewSizeCalculator(6)}`}; // 6rem
  height: ${() => `${viewSizeCalculator(3)}`}; // 3rem

  border-radius: ${() => `${viewSizeCalculator(1.25)}`}; // 1.25rem;
  border: ${() => `${viewSizeCalculator(2, true)} solid #ebebeb`};

  background-color: #f5f5f5;

  position: relative;

  display: flex;
  align-items: center;
  justify-content: space-around;

  cursor: pointer;
`;

export const SliderContentFirst = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  height: ${() => `${viewSizeCalculator(3)}`}; // 3rem
  width: ${() => `${viewSizeCalculator(3)}`}; // 3rem

  z-index: 200;
  svg {
    width: ${() => `${viewSizeCalculator(1)}`}; // 1rem
    height: ${() => `${viewSizeCalculator(1)}`}; // 1rem
  }
`;

export const SliderContentSecond = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: ${() => `${viewSizeCalculator(3)}`}; // 3rem
  height: ${() => `${viewSizeCalculator(3)}`}; // 3rem

  z-index: 200;

  svg {
    width: ${() => `${viewSizeCalculator(1.0206)}`}; // 3rem
    height: ${() => `${viewSizeCalculator(1)}`}; // 1rem
  }
`;

export const SliderHoverContainer = styled.div`
  width: ${() => `${viewSizeCalculator(3)}`}; // 3rem
  height: ${() => `${viewSizeCalculator(3)}`}; // 3rem

  border: ${() => `${viewSizeCalculator(2, true)} solid #ebebeb`};
  border-radius: ${() => `${viewSizeCalculator(1.25)}`}; // 1.25rem;

  background-color: #ffffff;

  position: absolute;

  z-index: 99;

  left: ${({ view }) => (view === views.MAP ? "50%" : "-3%")};

  transition: all 300ms ease-in-out;
`;

export const Center = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const ClearAll = styled.div`
  font-family: Inter;
  font-size: ${() => `${viewSizeCalculator(0.8125)}`}; // 0.8125rem
  font-weight: 500;
  line-height: ${() => `${viewSizeCalculator(0.9831)}`}; // 0.8125rem
  letter-spacing: 0%;

  cursor: pointer;
  color: #007bff;
  padding: 0 ${() => `${viewSizeCalculator(1)}`};
  border-radius: 10px;
  padding: 8px 12px;
  &:hover {
    background-color: #f5f5f5;
  }
`;
